(function ($) {
	$(".style-spotlight__right__inner").slick({
		dots: false,
		infinite: true,
		speed: 1500,
		slidesToShow: 2.5,
		autoplay: false,
		arrows: true,
		fade: false,
		rtl: true,
		draggable: true,
		prevArrow: '<div class="slick-prev"><svg width="31" height="12" viewBox="0 0 31 12" fill="none" xmlns="http://www.w3.org/2000/svg" class="arrow"><path d="M0.640625 6.63997H28.5357L24.5081 10.6675L25.4131 11.5725L30.9856 5.99997L25.4131 0.42749L24.5081 1.33245L28.5357 5.35997H0.640625V6.63997Z" /></svg></div>',
		nextArrow: '<div class="slick-next"><svg width="31" height="12" viewBox="0 0 31 12" fill="none" xmlns="http://www.w3.org/2000/svg" class="arrow"><path d="M0.640625 6.63997H28.5357L24.5081 10.6675L25.4131 11.5725L30.9856 5.99997L25.4131 0.42749L24.5081 1.33245L28.5357 5.35997H0.640625V6.63997Z" /></svg></div>',
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1.5,
					// centerMode: true,

				}
			}
		]
	}); 
	$(".product-detail__img__slider").slick({
		dots: true,
		infinite: false,
		speed: 1500,
		slidesToShow: 1,
		autoplay: false,
		arrows: true,
		fade: false,
		// rtl: true,
		draggable: false,
		prevArrow: '<div class="slick-prev"><svg width="31" height="12" viewBox="0 0 31 12" fill="none" xmlns="http://www.w3.org/2000/svg" class="arrow"><path d="M0.640625 6.63997H28.5357L24.5081 10.6675L25.4131 11.5725L30.9856 5.99997L25.4131 0.42749L24.5081 1.33245L28.5357 5.35997H0.640625V6.63997Z" /></svg></div>',
		nextArrow: '<div class="slick-next"><svg width="31" height="12" viewBox="0 0 31 12" fill="none" xmlns="http://www.w3.org/2000/svg" class="arrow"><path d="M0.640625 6.63997H28.5357L24.5081 10.6675L25.4131 11.5725L30.9856 5.99997L25.4131 0.42749L24.5081 1.33245L28.5357 5.35997H0.640625V6.63997Z" /></svg></div>',
		asNavFor: '.product-detail__img__thumb',
		// responsive: [
		// 	{
		// 		breakpoint: 768,
		// 		settings: {
		// 			accesibility: false,
		// 			draggable: false,
		// 			swipe: false,
		// 			touchMove: false,
		// 			swipeToSlide: false,
		// 		}
		// 	}
		// ] 
	});
	$(".product-detail__img__thumb").slick({
		dots: false,
		infinite: false,
		speed: 1500,
		slidesToShow: 5,
		autoplay: false,
		arrows: false,
		fade: false,
		draggable: true,
		asNavFor: '.product-detail__img__slider',
		focusOnSelect: true,
		vertical: true
	});
	$(".lastest-article .articles-section__list__inner").slick({
		dots: false,
		infinite: true,
		speed: 1500,
		slidesToShow: 2.5,
		autoplay: false,
		arrows: true,
		fade: false,
		rtl: true,
		draggable: true,
		prevArrow: '<div class="slick-prev"><svg width="31" height="12" viewBox="0 0 31 12" fill="none" xmlns="http://www.w3.org/2000/svg" class="arrow"><path d="M0.640625 6.63997H28.5357L24.5081 10.6675L25.4131 11.5725L30.9856 5.99997L25.4131 0.42749L24.5081 1.33245L28.5357 5.35997H0.640625V6.63997Z" /></svg></div>',
		nextArrow: '<div class="slick-next"><svg width="31" height="12" viewBox="0 0 31 12" fill="none" xmlns="http://www.w3.org/2000/svg" class="arrow"><path d="M0.640625 6.63997H28.5357L24.5081 10.6675L25.4131 11.5725L30.9856 5.99997L25.4131 0.42749L24.5081 1.33245L28.5357 5.35997H0.640625V6.63997Z" /></svg></div>',
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1.5,
				}
			}
		]
	});
	$(".featured-collection-custom ul.slider").slick({
		dots: false,
		infinite: true,
		speed: 1500,
		slidesToShow: 4,
		autoplay: false,
		arrows: true,
		fade: false,
		rtl: true,
		draggable: true,
		prevArrow: '<div class="slick-prev"><svg width="31" height="12" viewBox="0 0 31 12" fill="none" xmlns="http://www.w3.org/2000/svg" class="arrow"><path d="M0.640625 6.63997H28.5357L24.5081 10.6675L25.4131 11.5725L30.9856 5.99997L25.4131 0.42749L24.5081 1.33245L28.5357 5.35997H0.640625V6.63997Z" /></svg></div>',
		nextArrow: '<div class="slick-next"><svg width="31" height="12" viewBox="0 0 31 12" fill="none" xmlns="http://www.w3.org/2000/svg" class="arrow"><path d="M0.640625 6.63997H28.5357L24.5081 10.6675L25.4131 11.5725L30.9856 5.99997L25.4131 0.42749L24.5081 1.33245L28.5357 5.35997H0.640625V6.63997Z" /></svg></div>',
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1.5,
				}
			}
		]
	});
	// When the form code section is clicked, add the 'active' class to the form
	$('.book-appointment-section__form-code').click(function () {
		$('#book-appointment-form').addClass('active');
		$('html').addClass('overflow-hidden');
	});

	// When the close button is clicked, remove the 'active' class from the form
	$('#book-appointment-form .book-appointment-form__close').click(function () {
		$('#book-appointment-form').removeClass('active');
		$('html').removeClass('overflow-hidden');
	});


	$('.show-popup-contact-product').click(function () {
		$('#contact-us-product-popup').addClass('active');
		$('html').addClass('overflow-hidden');
	});
	// When the close button is clicked, remove the 'active' class from the form
	$('#contact-us-product-popup .book-appointment-form__close').click(function () {
		$('#contact-us-product-popup').removeClass('active');
		$('html').removeClass('overflow-hidden');
	});


	$('.show-leave-your-info').click(function () {
		$('#leave-your-info-popup').addClass('active');
		$('html').addClass('overflow-hidden');
	});
	// When the close button is clicked, remove the 'active' class from the form
	$('#leave-your-info-popup .book-appointment-form__close').click(function () {
		$('#leave-your-info-popup').removeClass('active');
		$('html').removeClass('overflow-hidden');
	});

	$(document).ready(function () {
		$('.brand-list__block-title').hover(function () {
			// Find the parent block
			var parentBlock = $(this).closest('.brand-list__block');

			// Get the title, link, image, and description
			var title = parentBlock.find('.brand-list__block-title a').text();
			var link = parentBlock.find('.brand-list__block-link').attr('href');
			var imageUrl = parentBlock.find('.brand-list__block-link img').attr('src');
			var description = parentBlock.find('.brand-list__block-description').text();

			// Update the our-brands section
			$('.our-brands__title').text(title);
			$('.our-brands__description').text(description);
			$('.our-brands__image img').attr('src', imageUrl);
			$('.our-brands__image img').attr('alt', title);
		}, function () {
			var defaultTitle = $(".our-brands__inner h2").data('default-title');
			var defaultSrc = $(".our-brands__inner img").data('default-src');
			$('.our-brands__title').text(defaultTitle);
			$('.our-brands__description').text('');
			$('.our-brands__image img').attr('src', defaultSrc);
			$('.our-brands__image img').attr('alt', defaultTitle);
		});
		// $('#section-brand-list').hover( 
		// 	function () {
		// 		// On hover in
		// 	},
		// 	function () {
		// 		// Reset to default content when hover out
		// 		var defaultTitle = $(".our-brands__inner h2").data('default-title');
		// 		var defaultSrc = $(".our-brands__inner img").data('default-src');
		// 		$('.our-brands__title').text(defaultTitle);
		// 		$('.our-brands__description').text('');
		// 		$('.our-brands__image img').attr('src', defaultSrc);
		// 		$('.our-brands__image img').attr('alt', defaultTitle);
		// 	}
		// );

	});

	// $(document).ready(function () {
	// 	let previousIndex = null;
	// 	let intervalId = null;

	// 	function setRandomActiveClass() {
	// 		let randomIndex;
	// 		do {
	// 			randomIndex = Math.floor(Math.random() * 8) + 1;
	// 		} while (randomIndex === previousIndex);

	// 		previousIndex = randomIndex;

	// 		$('.absolute-image').removeClass('active');
	// 		$('.absolute-image-' + randomIndex).addClass('active');
	// 	}

	// 	$('.home-banner').hover(
	// 		function () {
	// 			intervalId = setInterval(setRandomActiveClass, 1500);
	// 		},
	// 		function () {
	// 			clearInterval(intervalId);
	// 			$('.absolute-image').removeClass('active');
	// 		}
	// 	);
	// });
	// (function ($) {
	// 	var lastScrollTop = 0;
	// 	$(window).on('scroll', function (e) {
	// 		var st = $(this).scrollTop();
	// 		var scrollImage = $('.scroll-image');
	// 		var offsetTop = $(window).scrollTop();
	// 		// console.log(offsetTop);
	// 		console.log(parseInt(scrollImage.css('width')));

	// 		if (st > lastScrollTop) {
	// 			// Scroll down
	// 			scrollImage.css('width', (680 + offsetTop) + 'px');
	// 		} else {
	// 			// Scroll up
	// 			scrollImage.css('width', (parseInt(scrollImage.css('width')) - offsetTop) + 'px');
	// 		}
	// 		lastScrollTop = st;
	// 	});
	// })(jQuery);
	if ($('.scroll-image').length) {
		$(window).on('scroll resize', function () {
			const $element = $('.scroll-image');
			const elementOffset = $element.offset().top;
			const elementHeight = $element.outerHeight();

			const windowHeight = $(window).height();
			const scrollTop = $(window).scrollTop();
			const middleScreen = scrollTop + (windowHeight / 2);

			// Calculate dynamic zoom width
			const zoomFactor = Math.max(0, Math.min(1, (middleScreen - elementOffset + 150) / elementHeight));
			const newWidth = 680 + zoomFactor * 1500;
			console.log(newWidth);

			// Set new width
			$element.css('width', newWidth + 'px');
		});
	}


	new WOW().init();

	function animateText(texts) {
		// var texts = document.getElementsByClassName("animation-title");
		var animationDelay = 200;

		for (let j = 0; j < texts.length; j++) {
			var text = texts[j];
			if (!text.classList.contains('start-animation')) {
				var newDom = "";
				var words = text.innerText.split(" ");

				for (let i = 0; i < words.length; i++) {
					newDom +=
						'<span class="char">' +
						words[i] +
						"</span>" +
						(i < words.length - 1 ? "&nbsp;" : "");
				}

				text.innerHTML = newDom;
				var length = text.children.length;

				for (let i = 0; i < length; i++) {
					text.children[i].style["animation-delay"] =
						animationDelay * i + "ms";
				}
			}
		}
	}
	// animateText();

	function animation_title() {
		$('.animation-title').each(function () {
			var elementTop = $(this).offset().top;
			var elementBottom = elementTop + $(this).outerHeight();
			var viewportTop = $(window).scrollTop();
			var viewportBottom = viewportTop + $(window).height();
			// console.log(elementBottom > viewportTop && elementTop < viewportBottom);

			if (elementBottom > viewportTop && elementTop < viewportBottom) {
				// console.log("start animation");
				// console.log(this);

				animateText($(this));
				$(this).addClass('start-animation');


			}
		});
	}
	animation_title();
	$(window).on('scroll', function () {
		animation_title();
	});

	// window.addEventListener("scroll", function () {

	// 	for (let j = 0; j < texts.length; j++) {
	// 		var text = texts[j];
	// 		var rect = text.getBoundingClientRect();
	// 		if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
	// 			for (let i = 0; i < text.children.length; i++) {
	// 				text.children[i].style["animation-play-state"] =
	// 					"running";
	// 			}
	// 		} else {
	// 			for (let i = 0; i < text.children.length; i++) {
	// 				text.children[i].style["animation-play-state"] =
	// 					"paused";
	// 			}
	// 		}
	// 	}
	// });
	// Start animation when scroll to animation-title


	/// Pagination
	// $(document).ready(function () {
	// 	var products_on_page = $('.products-on-page');
	// 	var next_url = products_on_page.data('next-url');

	// 	var load_more_btn = $('.load-more_btn_product');
	// 	var load_more_spinner = $('.load-more_spinner');


	// 	$(window).on('scroll', function () {
	// 		var isLoading = false;

	// 		if (!isLoading && $(window).scrollTop() + $(window).height() >= $(document).height() - 100) {
	// 			isLoading = true;
	// 			console.log("click");

	// 			$.ajax({
	// 				url: next_url,
	// 				type: 'GET',
	// 				dataType: 'html',
	// 				beforeSend: function () {
	// 					load_more_btn.hide();
	// 					load_more_spinner.show();
	// 				},
	// 			}).done(function (next_page) {
	// 				load_more_spinner.hide();

	// 				var new_products = $(next_page).find('.products-on-page');
	// 				var new_url = new_products.data('next-url');
	// 				if (!new_url) {
	// 					$(window).off('scroll');
	// 				}

	// 				if (new_url) load_more_btn.show();

	// 				next_url = new_url;
	// 				products_on_page.append(new_products.html());
	// 			}).always(function () {
	// 				isLoading = false;
	// 			});
	// 		}
	// 	});
	// });

	$('#1col').click(function () {
		$('.boost-sd-container').addClass('col-1');
		$('#2col').removeClass('active');
		$('#1col').addClass('active');
	});
	$('#2col').click(function () {
		$('.boost-sd-container').removeClass('col-1');
		$('#1col').removeClass('active');
		$('#2col').addClass('active');
	});

	$(document).on('click', '.boost-sd__filter-option-label svg', function () {

		$(this).parents(".boost-sd__filter-option-label").find('.boost-sd__filter-option-title').trigger('click');
		$(this).parents(".boost-sd__filter-option-label").trigger('click');
	});

	$('.match-height').matchHeight();

	// $(document).on('click', '.collection-menu__inner ul li:nth-child(2)', function () {
	// 	console.log("click Men");
	// 	jQuery('#w-68b07509-704e28d-73044e90-452a1ca2').trigger('click');
	// });
	// $(document).on('click', '.collection-menu__inner ul li:nth-child(1)', function () {
	// 	console.log("click women");
	// 	jQuery('#w-676b31ad3a8305e0-1d02bceee37b6cc').trigger('click');
	// });

})(jQuery);
